import React, { useState, useEffect } from "react";

const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [rightPosition, setRightPosition] = useState("16px");

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const updatePosition = () => {
    const windowWidth = window.innerWidth;
    let rightEdge = 0;
    if (windowWidth > 1420) {
      // Calculate with offset for larger screens
      rightEdge = (windowWidth - 1200) / 2 - 140;
      setRightPosition(`${rightEdge}px`);
    } else if (windowWidth > 1023 && windowWidth < 1420) {
      // Calculate with offset for larger screens
      rightEdge = (windowWidth - 1400) / 2 + 140;
      setRightPosition(`${rightEdge}px`);
    } else if (windowWidth > 800) {
      // Calculate with offset for larger screens
      rightEdge = (windowWidth - 1400) / 2 + 200;
      setRightPosition(`${rightEdge}px`);
    } else {
      // Default padding for smaller screens
      setRightPosition("16px");
    }

    if (rightEdge < 0) {
      // Default padding for smaller screens
      setRightPosition("16px");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    window.addEventListener("resize", updatePosition);

    // Initial position calculation
    updatePosition();

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
      window.removeEventListener("resize", updatePosition);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          style={{ right: rightPosition }}
          className="fixed z-50 transition-all duration-300 rounded-full 
            bg-[#F3F0FF] border-2 border-[#805AED] shadow-insightful-light-gray shadow-lg
            hover:shadow-xl focus:outline-none ring-2 
            focus:ring-offset-2 ring-[#805AED]
            md:bottom-8 md:p-4
            bottom-4 p-3"
          aria-label="Back to top"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            className="md:w-6 md:h-6 w-5 h-5"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 20V4M12 4L5 11M12 4L19 11"
              stroke="#805AED"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}
    </>
  );
};

export default BackToTopButton;
